import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import styled from 'styled-components';
import carat from './Carat.svg';

import { trackHeaderProfileMenuClick } from '../tracking/header.tracking';
import useAuth from '../auth/useAuth';
import {
  STR_DASHBOARD,
  STR_GENIE,
  STR_MEASUREMENTS,
  STR_ORDERS,
  STR_POSTURE_CHECK,
  STR_PROFILE,
  STR_SIGNOUT,
} from '../tracking/header.tracking.constants';

const StyledCarat = styled.img`
  height: 9px;
  width: 12px;
  margin-left: 8px;
  margin-top: -3px;
`;
const StyledDropdownToggle = styled(Dropdown.Toggle)`
  padding-top: 3px;
  background-color: rgb(0, 0, 0, 0);
  border: 2px solid #b08217;
  border-radius: 8px;
  color: #b08217;
  font-size: 12pt;
  font-weight: 300;
  height: 34px !important;
  margin: -3px 0 24px 32px;
  max-height: 34px !important;
  min-height: 34px !important;
  padding: 2px 12px 0 12px;
  line-height: 7px;

  &:hover {
    background-color: rgb(0, 0, 0, 0);
    border: 2px solid #b08217;
    border-radius: 8px;
    color: #b08217;
  }
  &:focus {
    outline: 0;
  }
  ::after {
    border: 0;
  }

  @media (max-width: 991px) {
    margin: 32px 0;
  }
`;
const StyledDropdownMenu = styled(Dropdown.Menu)`
  top: 40px;
`;

const trackDashboardClick = () => {
  trackHeaderProfileMenuClick(STR_DASHBOARD);
};
const trackOrdersClick = () => {
  trackHeaderProfileMenuClick(STR_ORDERS);
};
const trackGenieClick = () => {
  trackHeaderProfileMenuClick(STR_GENIE);
};
const trackProfileClick = () => {
  trackHeaderProfileMenuClick(STR_PROFILE);
};
const trackMeasurementsClick = () => {
  trackHeaderProfileMenuClick(STR_MEASUREMENTS);
};
const trackPostureCheckClick = () => {
  trackHeaderProfileMenuClick(STR_POSTURE_CHECK);
};
const UserDropdown = ({ user }) => {
  const { logout, isAdmin } = useAuth();

  const handleLogout = () => {
    trackHeaderProfileMenuClick(STR_SIGNOUT);
    logout();
  };

  return (
    <Dropdown>
      <StyledDropdownToggle>
        <span>
          {user.firstName} {user.lastName}
        </span>
        <StyledCarat src={carat} />
      </StyledDropdownToggle>
      <StyledDropdownMenu align='right'>
        <Dropdown.Item>
          <LinkContainer to='/dashboard' onClick={trackDashboardClick}>
            <div>Dashboard</div>
          </LinkContainer>
        </Dropdown.Item>
        <Dropdown.Item>
          <LinkContainer to='/orders' onClick={trackOrdersClick}>
            <div>Orders</div>
          </LinkContainer>
        </Dropdown.Item>
        <Dropdown.Item>
          <LinkContainer to='/wardrobe' onClick={trackGenieClick}>
            <div>Genie</div>
          </LinkContainer>
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.Item>
          <LinkContainer
            to='/profile/account-details'
            onClick={trackProfileClick}
          >
            <div>Profile</div>
          </LinkContainer>
        </Dropdown.Item>
        <Dropdown.Item>
          <LinkContainer
            to='/my-measurements/jackets'
            onClick={trackMeasurementsClick}
          >
            <div>Measurements</div>
          </LinkContainer>
        </Dropdown.Item>
        <Dropdown.Item>
          <LinkContainer to='/posture-check' onClick={trackPostureCheckClick}>
            <div>Posture Check</div>
          </LinkContainer>
        </Dropdown.Item>
        {isAdmin && (
          <Dropdown.Item>
            <LinkContainer to='/admin'>
              <div>Admin</div>
            </LinkContainer>
          </Dropdown.Item>
        )}

        <Dropdown.Divider />

        <Dropdown.Item onClick={handleLogout}>
          <div>Sign out</div>
        </Dropdown.Item>
      </StyledDropdownMenu>
    </Dropdown>
  );
};
export default UserDropdown;
